<form [formGroup]="m1Form" *ngIf="m1Form" (ngSubmit)="onSubmit()" class="myform">
  <div class="p-5">
    <div class="flex justify-center items-baseline flex-wrap">
      <div class="flex m-2">
        <mat-form-field>
          <mat-label><span class="text-xs">Gamma (ɣ) &nbsp; value</span></mat-label>
          <input matInput formControlName="gammaVal" autocomplete="off">
          <mat-error *ngIf="m1Form.invalid && m1Form.touched">
            <span class="myerror">1.0 &lt; ɣ &le; 1.67</span>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex m-2">
        <mat-form-field>
          <mat-label><span class="text-xs">Upstream mach value (M1)</span></mat-label>
          <input matInput formControlName="m1Val" autocomplete="off">
          <mat-error *ngIf="m1Form.invalid && m1Form.touched">
            <span class="myerror">M1 must be supersonic</span>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="sbmtArea flex justify-center items-baseline flex-wrap">
      <button mat-raised-button type="submit" [disabled]="m1Form.invalid">Calculate</button>
    </div>
  </div>
</form>

<div class="flex justify-center items-baseline flex-wrap" *ngIf="m1Bool">
    <table>
        <tr>
    
          <td>
            <!-- <m2></m2> -->
            M2
          </td>
          <td>{{  nsm2() | number:'.1-5' }}</td>
    
        </tr>
    
        <tr>
          <td>
            <!-- <p2p1></p2p1> -->
            p2/p1
          </td>
          <td>
            {{ nsp2p1() | number:'.1-5' }}
          </td>
        </tr>
    
        <tr>
          <td>
            <!-- <t2t1></t2t1> -->
            t2/t1
          </td>
          <td>{{ nst2t1()  | number:'.1-5' }}</td>
    
        </tr>
    
        <tr>
          <td>
            <!-- <dva1></dva1> -->
            dva1
          </td>
          <td>
            {{  nsdva1() | number:'.1-5' }}
          </td>
        </tr>
    
        <tr>
          <td>
            <!-- <pt2pt1> </pt2pt1> -->
            pt2/pt1
          </td>
          <td>
            {{ nspt2_pt1()  | number:'.1-5' }}
          </td>
        </tr>
    
        <tr>
          <td>
            <!-- <pt2p1></pt2p1> -->
            pt2/p1
          </td>
          <td>
            {{  nspt2_p1() | number:'.1-5' }}
          </td>
        </tr>
      </table>
  </div>